/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ScorecardVersionOutFieldsItem } from './scorecardVersionOutFieldsItem';

export interface ScorecardVersionOut {
  id: string;
  version: number;
  fields: ScorecardVersionOutFieldsItem[];
  created_by_user_id: string | null;
  created_at: string;
}
